import { AccordionContainer, AccordionSection } from 'components/Accordion';
import { selectFooterGroups } from 'components/Footer/selector';
import { isMobileLayout } from 'components/Shared/responsive';
import { useSelector } from 'react-redux';
import styles from './links.scss';
import { FooterItemProps } from 'components/Footer/themes/PP/footer';

interface Props extends FooterItemProps {
  className?: string;
}

export const Links = ({ className, onNavClick }: Props) => {
  const mobile = useSelector(isMobileLayout);
  const groups = useSelector(selectFooterGroups);

  const content = mobile ? (
    <div className={styles.mobile}>
      <AccordionContainer>
        {groups?.map(({ displayName, links }) => (
          <AccordionSection key={displayName} title={displayName}>
            <ul className={styles.list}>
              {links.map(({ displayName, link }) => (
                <li key={displayName} className={styles.link}>
                  <a onClick={() => onNavClick(link)} href={link}>
                    {displayName}
                  </a>
                </li>
              ))}
            </ul>
          </AccordionSection>
        ))}
      </AccordionContainer>
    </div>
  ) : (
    <div className={styles.desktop}>
      {groups?.map(({ displayName, links }) => (
        <div key={displayName} className={styles.section}>
          <div className={styles.title}>{displayName}</div>
          <ul className={styles.list}>
            {links.map(({ displayName, link }) => (
              <li key={displayName} className={styles.link}>
                <a onClick={() => onNavClick(link)} href={link}>
                  {displayName}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );

  return <div className={className}>{content}</div>;
};
